import { FunctionComponent, useEffect } from "react";
import ProductCard from "../../ProductCard";
import "./styles.scss";

type Props = {
  products: Product[];
};
const CategoryBody: FunctionComponent<Props> = ({ products }) => {
  const scrollY = localStorage?.getItem("scrollY");

  useEffect(() => {
    if (scrollY) {
      window.scrollTo(0, Number(scrollY));
      localStorage.removeItem("scrollY");
    }
  }, []);

  return (
    <section className="category__body">
      {products.map((product) => (
        <ProductCard
          key={product["_id"]}
          img={product.thumbnailUrl}
          title={product.title}
          friendlyUrl={product.friendlyUrl}
          sku={product.sku}
        />
      ))}
    </section>
  );
};

export default CategoryBody;
